import { useEffect, useState } from 'react';
import { useMutation } from '@tanstack/react-query';
import * as service from '../services';
import { useDebounce } from '../../../../../hooks';
import { useAnaliseCoberturaStore } from '../AnaliseCobertura.store';

export const useAnaliseCoberturaRede = () => {
  const { setCoverageAnalysisState, coberturaRedeParams } = useAnaliseCoberturaStore();

  const debounce = useDebounce(500);

  const coberturaRedeSuccess = data => {
    setCoverageAnalysisState('coberturaRedeData', data.data);
  };

  const mutation = useMutation({
    mutationFn: data => service.getAnaliseCoberturaRede(data),
    onSuccess: data => coberturaRedeSuccess(data),
  });

  const handleChangeCoberturaRedePeriod = (value: number) => {
    const param = { ...coberturaRedeParams, diasAnalise: value };
    setCoverageAnalysisState('coberturaRedeParams', param);
    mutation.mutateAsync(param);
  };

  const handleChangeCoberturaRedeSearch = (value: number) => {
    const param = { ...coberturaRedeParams, query: value, page: 0 };
    debounce(() => {
      setCoverageAnalysisState('coberturaRedeParams', param);
      mutation.mutateAsync(param);
    });
  };

  const handleChangeCoberturaRedePagination = (value: number) => {
    const param = { ...coberturaRedeParams, page: value - 1 };
    setCoverageAnalysisState('coberturaRedeParams', param);
    mutation.mutateAsync(param);
  };

  useEffect(() => {
    mutation.mutateAsync(coberturaRedeParams);
  }, []);

  return {
    coberturaRedeLoading: mutation.isLoading,
    handleChangeCoberturaRedePeriod,
    handleChangeCoberturaRedeSearch,
    handleChangeCoberturaRedePagination,
  };
};
